export type BdrSettlementCalendarsBlackoutDatesState = IDictionary<string[]>;

export const initialBdrSettlementCalendarsBlackoutDatesState = {};
